// extracted by mini-css-extract-plugin
export default {"text":"text_TaskTabs-module_XniMv","wrapper":"wrapper_TaskTabs-module_1WrfI","tabs":"tabs_TaskTabs-module_1IQxX","editIcon":"editIcon_TaskTabs-module_1osL9"};